<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ViewerPill from '@/components/bop/ViewerPill.vue'

defineProps<{
  articleNumber: string
  required: number
  picked: number
  canSave: boolean
}>()

const emit = defineEmits<{
  cancel: []
  save: []
}>()

const { t } = useI18n()
</script>

<template>
  <viewer-pill floating>
    <v-icon size="18" color="primary">touch_app</v-icon>
    <span class="viewer-picking-bar__label">
      {{ t('component.bopModelViewer.pickInstances', { required, article: articleNumber }) }}
    </span>
    <v-chip size="small" variant="tonal" :color="canSave ? 'success' : undefined">
      {{ picked }}/{{ required }}
    </v-chip>
    <v-divider vertical class="mx-1" />
    <v-btn size="small" variant="text" @click="emit('cancel')">
      {{ t('button.cancel') }}
    </v-btn>
    <v-btn size="small" variant="flat" color="primary" :disabled="!canSave" @click="emit('save')">
      {{ t('button.save') }}
    </v-btn>
  </viewer-pill>
</template>

<style scoped>
.viewer-picking-bar__label {
  max-width: 320px;
  font-size: 0.8em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
}
</style>
